import ParentHeader from "./header";

export const ParentLayout = ({ className = '', children }: { className?: string, children: React.ReactNode }) => {
    return (
        <>
            <div className={`${className}`}>
                <ParentHeader zoom={false}/>
                {children}
            </div>
        </>
    );
};
